/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfirmPasswordRequest as DigiworkMaitreDDtoAuthenticationConfirmPasswordRequest } from '../../models/Digiwork/MaitreD/DTO/Authentication/confirm-password-request';

export interface ConfirmPassword$Params {
      body?: DigiworkMaitreDDtoAuthenticationConfirmPasswordRequest
}

export function confirmPassword(http: HttpClient, rootUrl: string, params?: ConfirmPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, confirmPassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

confirmPassword.PATH = '/api/pos/User/confirmpassword';
